module.exports = __webpack_public_path__ + "img/baa_platinum.5add6420.png";